import {Component, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {LoanTermsSelectionComponent, } from './loan-terms-selection.component';
import {UntilDestroy} from '@ngneat/until-destroy';
import {MARK, Mark} from '@portal-workspace/grow-ui-library/mark';
import {BusinessLoanTermValueOptions} from '@portal-workspace/grow-shared-library';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DisableControlDirective } from '../../directives/disable-control.directive';

@UntilDestroy()
@Component({
    selector: 'business-loan-terms-selection',
    templateUrl: './loan-terms-selection.component.html',
    styleUrls: ['./loan-terms-selection.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => BusinessLoanTermsSelectionComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => BusinessLoanTermsSelectionComponent) },
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, NgFor, MatOptionModule, NgIf, DisableControlDirective]
})
export class BusinessLoanTermsSelectionComponent extends LoanTermsSelectionComponent implements Mark {
  override mark() {
    this.formGroup.markAllAsTouched();
  }
  override options = BusinessLoanTermValueOptions;
}
